import { BLOG_CATEGORY, buildBlogFilePath, type BlogMetaData } from '../types';

export const nurseryVisitOutfit: BlogMetaData = {
  title: '保育園見学の服装・持ち物リスト｜子連れ見学の注意点とマナー',
  description:
    '保育園見学の服装はきれいめ普段着が基本。避けたい服装、持ち物チェックリスト、子連れ見学の準備、見学時間や土曜見学など予約時に確認したいポイントまで、園に失礼のない実践的なマナーをまとめました。',
  thumbnailUrl: '/img/blog-nursery-visit-outfit.webp',
  filePath: buildBlogFilePath('nursery-visit-outfit'),
  category: BLOG_CATEGORY.NURSERY,
};
